import { Route, Navigate, Routes } from 'react-router-dom';
// layouts
import {useState} from 'react';
import AdminLayout from './layouts/admin';
import LoginPage from './pages/LoginPage';
import Page404 from './pages/Page404';
import HomePage from './pages/HomePage';
import MovieDetailsPage from './pages/MovieDetailsPage'
import AdminDashboardPage from './pages/AdminDashboardPage';
import { AUTH_TOKEN } from './auth/const'
import DefaultLayout from './layouts/default/DefaultLayout';
import ContactsPage from './pages/ContactsPage';
import AboutUsPage from './pages/AboutUsPage';
import SponsorPage from './pages/SponsorPage';
import AdminMovieBookingsPage from './pages/AdminMovieBookingsPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import ServicesPage from './pages/ServicesPage';
import data from './config.json';
import CancelBookingPage from './pages/CancelBookingPage';


export default function Router() {
  let [token, setToken] = useState(localStorage.getItem(AUTH_TOKEN));

  return (
    <Routes>
        
        {(token !== '' && token !== null && token !== undefined) && 
        <>
          <Route path={`${process.env.PUBLIC_URL}/admin`} element={<AdminLayout setToken={setToken} />}>
            <Route path={`${process.env.PUBLIC_URL}/admin`} element={<AdminDashboardPage />} index={true}></Route>
            <Route path={`${process.env.PUBLIC_URL}/admin/movies/:id`} element={<AdminMovieBookingsPage />}></Route>
          </Route>
        </>}
        
        {/* PUBLIC */}
        <Route path={`${process.env.PUBLIC_URL}/`} element={<DefaultLayout/>}>
          <Route path={`${process.env.PUBLIC_URL}/cancel_booking/:token`} element={<CancelBookingPage />}></Route>
          <Route path={`${process.env.PUBLIC_URL}/`} element={<HomePage />}></Route>
          <Route path={`${process.env.PUBLIC_URL}/movies/:id`} element={<MovieDetailsPage />} index={true}></Route>
          <Route path={`${process.env.PUBLIC_URL}/about_us`} element={<AboutUsPage />}></Route>
          <Route path={`${process.env.PUBLIC_URL}/contacts`} element={<ContactsPage />}></Route>
          <Route path={`${process.env.PUBLIC_URL}/services`} element={<ServicesPage />}></Route>
          <Route path={`${process.env.PUBLIC_URL}/sponsors`} element={<SponsorPage />}></Route>
          <Route path={`${process.env.PUBLIC_URL}/privacy_policy`} element={<PrivacyPolicyPage />}></Route>
          
        </Route>

        {(token === '' || token === null || token === undefined) ? 
          <>
            <Route path={`${process.env.PUBLIC_URL}/admin/login`} element={<LoginPage setToken={setToken} />}></Route>
            <Route path={`${process.env.PUBLIC_URL}/*`} element={<Navigate to={`${process.env.PUBLIC_URL}/`} />}></Route>
          </> :
          <>
            <Route path={`${process.env.PUBLIC_URL}/*`} element={<Navigate to={`${process.env.PUBLIC_URL}/404`} />}></Route>
            <Route path={`${process.env.PUBLIC_URL}/admin/login`} element={<Navigate to={`${process.env.PUBLIC_URL}/admin`} />}></Route>
          </>
        }
        <Route path={`${process.env.PUBLIC_URL}/404`} element={<Page404 />}></Route>
    </Routes>)
}